<template>
  <div class="navbar-header app-navbar-brand d-xl-block d-none">
    <ul class="nav navbar-nav">
      <li class="nav-item">
        <b-link
          class="navbar-brand app-navbar-brand-link"
          to="/planning"
        >
          <span class="brand-logo">
            <b-img
              :src="appLogoImage"
              alt="logo"
            />
          </span>
          <h2 class="brand-text mb-0">
            {{ appName }}
          </h2>
        </b-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BLink,
    BImg,
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
}
</script>

<style lang="scss" scoped>
.app-navbar-brand {
  position: absolute !important;
  top: 50%;
  left: 50% !important;
  width: auto !important;
  height: auto;
  padding: 0 !important;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

.app-navbar-brand-link {
  display: flex !important;
  align-items: center;
  margin: 0;
  white-space: nowrap;
  color: #16B5EA !important;
}

.app-navbar-brand-link .brand-logo img {
  width: auto;
  height: 26px !important;
}

.app-navbar-brand-link .brand-text {
  color: #16B5EA !important;
  font-size: 1.45rem !important;
  font-weight: 700 !important;
  margin-left: 4px;
}
</style>
